import React from 'react';
import DishCard from './DishCard';

function MenuList({ dishes, isLoading, error, onDishClick }) {

    // Skeleton moderno enquanto carrega os dados
    if (isLoading) {
        return (
            <div className="max-w-5xl mx-auto px-6 py-8 w-full">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                    {[1, 2, 3, 4, 5, 6].map(i => (
                        <div key={i} className="flex bg-white/50 border border-[#dbcdac]/30 rounded-2xl p-4 h-36 md:h-40 animate-pulse">
                            <div className="flex-1 pr-4 flex flex-col justify-between">
                                <div>
                                    <div className="h-5 bg-stone-200 rounded-md w-3/4 mb-3"></div>
                                    <div className="h-3 bg-stone-100 rounded-md w-full mb-1.5"></div>
                                    <div className="h-3 bg-stone-100 rounded-md w-5/6"></div>
                                </div>
                                <div className="h-6 bg-stone-200 rounded-md w-1/3"></div>
                            </div>
                            <div className="w-28 h-28 md:w-32 md:h-32 bg-stone-200 rounded-xl"></div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    if (error) return <div className="text-center py-20 text-red-800 font-medium">{error}</div>;
    if (dishes.length === 0) return <div className="text-center py-20 font-serif text-xl text-[#528a89] italic">Nenhum prato encontrado nesta categoria.</div>;

    return (
        <div className="max-w-5xl mx-auto px-6 py-8 w-full">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                {dishes.map((dish) => (
                    <DishCard 
                        key={dish.nome} 
                        dish={dish} 
                        onDishClick={onDishClick} 
                    />
                ))}
            </div>
        </div>
    );
}

export default MenuList;